export default __webpack_public_path__ + "static/muli-v20-latin-700-d76170ba51f472fb6cd6ee5f731f6524.eot";